import { z } from "zod";

export const listRecommendationTemplatesInputSchema = z.object({
  organizationId: z.string().min(1),
  defaultItemId: z.string().min(1),
});

export const recommendationTemplateSchema = z.object({
  id: z.string(),
  organizationId: z.string(),
  textTemplate: z.string(),
  urgency: z.enum(["maint", "asap", "critical"]),
  defaultAreaId: z.string().nullable(),
  defaultItemId: z.string().nullable(),
  createdAt: z.string(),
});

export const listRecommendationTemplatesResponseSchema = z.object({
  templates: z.array(recommendationTemplateSchema),
});

export const createRecommendationTemplateInputSchema = z.object({
  organizationId: z.string().min(1),
  textTemplate: z.string().min(1),
  urgency: z.enum(["maint", "asap", "critical"]),
  defaultAreaId: z.string().nullable().optional(),
  defaultItemId: z.string().min(1),
});

export const updateRecommendationTemplateInputSchema = z
  .object({
    organizationId: z.string().min(1),
    textTemplate: z.string().min(1).optional(),
    urgency: z.enum(["maint", "asap", "critical"]).optional(),
  })
  .refine(
    (value) => value.textTemplate !== undefined || value.urgency !== undefined,
    {
      message: "At least one field is required",
    },
  );

export const updateRecommendationTemplateResponseSchema = z.object({
  template: recommendationTemplateSchema,
});

export const deleteRecommendationTemplateParamsSchema = z.object({
  id: z.string().min(1),
});

export const deleteRecommendationTemplateInputSchema = z.object({
  organizationId: z.string().min(1),
});

export const listSurveyRecommendationsInputSchema = z.object({
  surveyId: z.string().min(1).optional(),
});

export const surveyRecommendationSchema = z.object({
  id: z.string(),
  surveyId: z.string(),
  areaId: z.string(),
  itemId: z.string(),
  recommendationText: z.string(),
  sourceTemplateId: z.string().nullable(),
  createdAt: z.string(),
});

export const listSurveyRecommendationsResponseSchema = z.object({
  recommendations: z.array(surveyRecommendationSchema),
});

export const createSurveyRecommendationInputSchema = z.object({
  surveyId: z.string().min(1).optional(),
  areaId: z.string().min(1),
  itemId: z.string().min(1),
  recommendationText: z.string().min(1),
  sourceTemplateId: z.string().nullable().optional(),
});

export const deleteSurveyRecommendationParamsSchema = z.object({
  id: z.string().min(1),
});
